const InputTypes = {
  TEXT_INPUT: "text input",
  PICKER: "picker",
  CHECKBOX: "checkbox"
}

export const AdminTypes = {
  USER: "user",
  ADMIN: "admin",
  OWNER: "owner"
}

export default InputTypes;